import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 64F3926D-42E9-4819-92A2-C524031CD9BA
 * name panorama-wide-angle
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/panorama-wide-angle.svg
 * tags
 * - Photography 
 */
export const PanoramaWideAngleIcon = createSvgIcon(<><path d="M12 4C8 4 5.2 4.6 3 5C2.5 7 2 8.9 2 12C2 15 2.5 17 3 19C5.2 19.4 8 20 12 20C16 20 18.9 19.4 21 19C21.6 17 22 15 22 12C22 9 21.5 6.9 21 5C18.9 4.6 16 4 12 4Z" /></>, 'PanoramaWideAngleIcon');
export default PanoramaWideAngleIcon